module.exports = __webpack_public_path__ + "img/sweet-bread.8dcec28f.svg";